import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tutorial-calendar',
  templateUrl: './tutorial-calendar.component.html',
  styleUrls: ['./tutorial-calendar.component.css']
})
export class TutorialCalendarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}